var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 32,
    viewBox: "0 0 164 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_3841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6513 25.3687L14.9238 31.6994L22.3674 31.6823L18.6513 25.3687Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1969 12.6846L0 31.6883H7.45503L14.9244 19.0153L11.1969 12.6846Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.377 19.0811L29.8949 31.797H37.3128L26.0844 12.7847L22.377 19.0811Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3674 6.31075L18.6513 0L14.9238 6.32791L18.6399 12.6415L22.3674 6.31075Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3635 13.5683C89.633 13.5683 91.8786 15.6337 91.8786 19.1066C91.8786 21.8272 89.879 23.7954 86.9754 24.193L92.4136 31.6967H88.3342L83.1048 24.5964H75.7871V31.6967H72.5859V13.5654H84.3664L84.3635 13.5683ZM75.7842 16.7637V21.4496H84.8212C86.6893 21.4496 88.6746 21.298 88.6746 19.1066C88.6746 16.9153 86.1286 16.7637 84.7554 16.7637H75.7814H75.7842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.431 32.0001L123.907 20.1738L123.141 19.5445V31.6997H119.939V13.2681H119.974L134.498 25.0943L135.264 25.7236V13.5684H138.465V32.0001H138.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8399 31.6996H69.6275L58.5537 12.8818H58.4879L47.4141 31.6996H51.2017L53.0983 28.4241H63.9147L65.8399 31.6996ZM58.5194 18.9494C60.0727 21.4525 60.7393 22.634 62.3041 25.2974H54.7032C56.3366 22.5282 56.9546 21.4525 58.5194 18.9494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.619 31.6996H163.407L152.333 12.8818H152.267L141.193 31.6996H144.981L146.878 28.4241H157.694L159.619 31.6996ZM152.299 18.9494C153.852 21.4525 154.519 22.634 156.083 25.2974H148.482C150.116 22.5282 150.734 21.4525 152.299 18.9494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.884 28.5013V24.1072H113.316V20.9805H100.884V16.7666H114.738V13.5684H97.6797V31.6996H115.239V28.5013H100.884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_3841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.407,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoColor);
export default __webpack_public_path__ + "static/media/ic_logo-color.ae364a13079f431adf947b8c23d9a6fc.svg";
export { ForwardRef as ReactComponent };